module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.pairingBriefModelSections[1].content), function(campaignField, index) {
    return _c('element', {
      key: index
    }, [(campaignField.type === 'text') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
      staticClass: "form-group col-xs-12"
    }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
      return _c('div', {
        key: optionIndex,
        staticClass: "form-group col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))])]), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
        return _c('element', {
          key: index
        }, [(optionField.type == 'text') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image) {
          return [(image != '') ? _c('div', {
            key: image
          }, [_c('a', {
            key: image,
            staticClass: "campaign-image",
            attrs: {
              "href": _vm.constructImageURL(image),
              "target": "_blank"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": _vm.constructImageURL(image)
            }
          })])]) : _vm._e()]
        })], 2)]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(optionField.value, _vm.campaign[campaignField.name][optionIndex][optionField.name])))])]) : _vm._e()])
      })], 2)
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12"
  }, [_c('label', [_vm._v("Payout:")]), _vm._v(" $" + _vm._s(_vm.rateCardData) + "\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Pairing Brief\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('h3', [_vm._v("Pairing Brief Details")])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("\n          MUST READ "), _c('br'), _vm._v("\n          (Drop us an email at huanrong@getkobe.com if you need any help) "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n          Reminder:"), _c('br'), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Both client and influencer will be mutually rated after each campaign and scores will be kept with Kobe to keep making the world a better place.")]), _vm._v(" "), _c('li', [_vm._v(" Do not make your post live until approval from client.")]), _vm._v(" "), _c('li', [_vm._v(" It is NON-MANDATORY for client to be giving a discount or any value added services.")]), _vm._v(" "), _c('li', [_vm._v(" For any discounts or value-added services that has been extended to you - it is entirely up to the sole discretion of the client - KOBE is not commissioned, neither do we enjoy similar perks.")]), _vm._v(" "), _c('li', [_vm._v(" KOBE gets you rewarded and recognized for sharing on social media, whilst at the same time provide word of mouth to businesses. Kobe isn’t a money making platform. ")]), _vm._v(" "), _c('li', [_vm._v(" For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation from campaign.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4845f2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ViewPairingBriefDetailedModal.vue
// module id = 2319
// module chunks = 0